
import { Prop } from 'vue-property-decorator';
import * as OM from '@/Model';
import { Options, Vue } from 'vue-class-component';
import Toggler from '@/components/toggler.vue';
import CourseContentModal from './courseContentModal.vue';

@Options({})
export default class ProductCourse extends Vue {
 
    @Prop() product: OM.ProductCourse;

    created(){
        if(!this.product.courseContents)
            this.product.courseContents = [];
    }
    
    openContentModal(item: OM.CourseContent){
        this.$opModal.show(CourseContentModal, {
            content: item
        })
    }

    pushContent(){
        this.product.courseContents.push(new OM.CourseContent());
    }

    removeContent(i: number){
        if(this.product.courseContents[i].url){
            if(!confirm("Confermi rimozione?"))
                return;
        }
        this.product.courseContents.splice(i, 1);
    }

    moveSx(i){
        this.array_move(this.product.courseContents, i, i - 1);
    }

    moveDx(i){
        this.array_move(this.product.courseContents, i, i + 1);
    }

    array_move(arr: any[], old_index: number, new_index: number) {
        if (new_index >= arr.length) {
            return;
        }
        let old = arr.splice(old_index, 1);
        arr.splice(new_index, 0, old[0]);
    };
}

